<template>
  <router-link tag="div" class="card-link" :to="linkTo" append>
    <div class="card translucent-border" style="width: 200px;">
      <div class="card-body">
        <h5 class="card-title">{{ label }}</h5>
      </div>

      <div class="card-body img-wrap" :style="{ backgroundImage: 'url(' + iconUrl + ')' }">

      </div>

      <div class="card-body value-wrap">
        <p v-if="value == null" class="card-text text-warning">
          VALITSE
        </p>
        <p v-if="value != null && isMultiRow" class="card-text">
          <span style="display: block;" v-for="valueRow in valueRows">{{ valueRow }}</span>
        </p>
        <p v-if="value != null && !isMultiRow" class="card-text">
          {{ value }}
          <span v-if="unit">{{ unit }}</span>
        </p>
      </div>

      <div class="card-footer" :class="{ 'bg-success': value != null, 'bg-warning': value == null }">

      </div>
    </div>
  </router-link>
</template>


<script>
  export default {
    props: {
      linkTo: null,
      unit: null,
      iconUrl: null,
      label: null,
      value: null,
      type: null,
      ok: false
    },

    computed: {
      isMultiRow() {
        if(this.value == null) {
          return false
        }
        return this.value.toString().split('|').length > 1
      },

      valueRows() {
        if(this.value == null) {
          return null
        }
        return this.value.toString().split('|')
      }
    }
  }
</script>

<style scoped>
  .card {
    position: relative;
    cursor: pointer;
  }

  .card:hover {
    border-color: rgba(0, 255, 0, 0.5);
  }

  .card-title, .card-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .card-body {
    text-align: center;
    padding: 10px;
  }

  .img-wrap {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    height: 160px;
    text-align: center;
  }

  .value-wrap {
    height: 70px;
  }

  .card-link {
    display: inline-block;
    margin: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ParamCard.vue